import { useTranslation } from 'react-i18next';
import BubbleButton from '../../../Buttons/BubbleButton/BubbleButton';
import styles from './VerificationBanner.module.css';
import { VerifyBadge } from '../../../../../assets/images/icons';

function VerificationBanner({ checkMark, setFullViewList, fullViewList, job, ...props }) {
    const { t } = useTranslation();

    return (
        <div className={styles.container}>
            <div className={styles.titleWrapper}>
                <p className={styles.bannerHeading}>{t('verificationBanner.heading')}</p>
                <div>
                    <p className={styles.bannerDesc}>{t('verificationBanner.descriptionLine1')}</p>
                    <p className={styles.bannerDesc}>{t('verificationBanner.descriptionLine2')}</p>
                </div>
                <div className={styles.verifycationButton}>
                    {checkMark &&
                        <BubbleButton
                            to="/subscriptions"
                            headerButton>{t('verificationBanner.buttonText')}</BubbleButton>}
                </div>
            </div>
            {checkMark ?
                <div>
                    <img src={VerifyBadge} alt="image" className={styles.image} />
                </div>
                :
                <BubbleButton
                    to="/subscriptions"
                    headerButton>{t('verificationBanner.buttonText')}</BubbleButton>
            }
        </div>
    );
}

export default VerificationBanner;
